import React from 'react'

// Styled Elements
import {
  SubHeaderWrapper,
  SubHeaderNavList,
  SubHeaderNavListItem,
  SubHeaderNavListLink,
} from './AICatalystSubHeader.elements'

function AICatalystSubHeader() {
  return (
    <SubHeaderWrapper>
      <SubHeaderNavList>
        <SubHeaderNavListItem>
          <SubHeaderNavListLink exact activeClassName="active" to="/ai-catalyst/regulatory">
            Regulatory Insights
          </SubHeaderNavListLink>
        </SubHeaderNavListItem>
        <SubHeaderNavListItem>
          <SubHeaderNavListLink exact activeClassName="active" to="/ai-catalyst/ospree">
            Ospree Get Started
          </SubHeaderNavListLink>
        </SubHeaderNavListItem>
      </SubHeaderNavList>
    </SubHeaderWrapper>
  )
}

export default AICatalystSubHeader
